import {useCallback,useEffect,useRef,useState} from 'react';
import {identityRequest} from '../services/identity/nuban';
export const CONTACT_FLOW='email_phone_v1';
export function normalizeContactPhone(value){
 let phone=String(value||'').trim().replace(/[ ()-]/g,'');
 if(phone.startsWith('+234'))phone='0'+phone.slice(4);
 else if(phone.startsWith('234'))phone='0'+phone.slice(3);
 return phone;
}
export function contactErrors(email,phone){
 return {
  email:!email?'Enter your email address.':email.length>254||! /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)?'Enter a valid email address.':'',
  phone:!phone?'Enter your phone number.':!/^0[789]\d{9}$/.test(phone)?'Enter a valid 11-digit Nigerian phone number.':''
 };
}
export default function useRegistrationContacts(rawEmail,rawPhone,enabled){
 const email=rawEmail.trim().toLowerCase(),phone=normalizeContactPhone(rawPhone);
 const key=JSON.stringify([email,phone]);
 const latest=useRef(key);latest.current=key;
 const generation=useRef(0);
 const invalidate=useCallback(()=>{generation.current++;},[]);
 const [result,setResult]=useState(null),[attempt,setAttempt]=useState(0);
 const errors=contactErrors(email,phone),valid=!errors.email&&!errors.phone;
 const check=useCallback(async(requireBoth=true)=>{
  const id=++generation.current;
  const current=()=>latest.current===key&&generation.current===id;
  const fields=contactErrors(email,phone);
  if(!enabled||(requireBoth&&!valid)||(fields.email&&fields.phone))throw Error('Enter valid contact details first.');
  const payload={...(!fields.email?{email}:{}),...(!fields.phone?{phone}:{}),contact_flow:CONTACT_FLOW};
  setResult({key,state:'checking'});
  try{
   const r=await identityRequest('/api/registration/validate-contact',payload);
   if(!current())throw Error('Contact details changed. Check them again.');
   if(r.status!==true||r.valid!==true||(!fields.email&&r.contact?.email!==email)||(!fields.phone&&normalizeContactPhone(r.contact?.phone)!==phone))throw Error('Contact availability was not confirmed. Please retry.');
   setResult({key,state:'available'});return {email,phone,contact_flow:CONTACT_FLOW};
  }catch(e){if(current())setResult({key,state:'error',fields:e.fields||{},message:e.fields?'Check your contact details.':'Unable to check availability. Please retry.'});throw e;}
 },[email,phone,key,valid,enabled]);
 useEffect(()=>{
  if(!enabled||(contactErrors(email,phone).email&&contactErrors(email,phone).phone))return;
  const timer=setTimeout(()=>{check(false).catch(()=>{});},500);
  return()=>{clearTimeout(timer);invalidate();};
 },[check,attempt,enabled,email,phone,invalidate]);
 const matched=result?.key===key?result:null;
 const ready=enabled&&valid&&matched?.state==='available';
 const message=field=>errors[field]||matched?.fields?.[field]||(matched?.state==='error'?matched.message:matched?.state==='available'?'Available':'Checking availability…');
 return {email,phone,ready,check,retry:()=>setAttempt(n=>n+1),failed:matched?.state==='error',message,invalid:field=>Boolean(errors[field]||matched?.fields?.[field])};
}
